<div>
  <h4>{{ "DEVICE.SELECT_DASHBOARD" | translate }}</h4>
  <mat-form-field class="fullWidth">
    <mat-label>Dashboards</mat-label>
    <div class="space10"></div>
    <mat-select (selectionChange)="selectedDashboard($event)">
      <mat-option *ngFor="let dash of userDashboards" [value]="dash.uuid">
        {{ dash.name }}
      </mat-option>
    </mat-select>
  </mat-form-field>
  <div class="space10"></div>
  <button
    mat-raised-button
    [disabled]="!selectedDash"
    (click)="saveDashboardAdd()"
    class="primaryBtn float-right text-right"
  >
    {{ "CONFIRM_MODAL.ACCEPT" | translate }}
  </button>
</div>
